export const createToken = (payload, key) => {
    if (typeof window !== 'undefined') {
        return new Promise((resolve, reject) => {
            const xenditKey = key;
            window.Xendit.setPublishableKey(xenditKey);

            window.Xendit.card.createToken(payload, (err, response) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(response);
                }
            });
        });
    }

    return false;
};

export default { createToken };
